import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import { postGetBatchListsAPI } from 'api/bulk-transactions'
import {
  BatchTypes,
  LookupBatchListsServiceTypes,
  BatchLookupTxFormTypes,
  BatchLookupTxSetFieldTypes,
  BatchLookupTxFormSubmitValuesTypes,
} from 'types/bulkTransactionsTXTypes'

import { DropDownItem } from 'types/components'

const BatchLookupTxINITVAL: BatchLookupTxFormTypes = {
  value: '',
  field: '',
}

const INITIAL_LOOKUP_PARAMS: LookupBatchListsServiceTypes = {
  batchId: null,
  batchName: null,
  batchStatusId: null,
  dataSourceTypeId: null,
  traderTypeId: null,
  flTest: null,
  flBusiness: null,
  flGeneric: null,
  traderCountMinimum: null,
  traderCountMaximum: null,
  tradersMaximumMin: null,
  tradersMaximumMax: null,
  identTypeId: null,
  identCreationModeId: null,
}

export const useBatchLookupTx = (
  setFieldValue: BatchLookupTxSetFieldTypes
): {
  allBatches: BatchTypes[]
  initialValues: BatchLookupTxFormTypes
  handleSubmitBatchLookupTx: (values: BatchLookupTxFormSubmitValuesTypes) => void
  batchLookupDropdownOptions: (input: string) => Promise<DropDownItem[]>
} => {
  // STATES
  const [allBatches, setAllBatches] = useState<BatchTypes[]>([])
  const [initialValues] = useState<BatchLookupTxFormTypes>(BatchLookupTxINITVAL)

  useEffect(() => {
    const fetchAllBatches = async () => {
      try {
        const result = await postGetBatchListsAPI(INITIAL_LOOKUP_PARAMS)
        setAllBatches(result.data)
      } catch (error) {
        toast.error('Failed to fetch batch list.')
      }
    }
    fetchAllBatches()
  }, [])

  const handleSubmitBatchLookupTx = useCallback(
    async (values: BatchLookupTxFormSubmitValuesTypes) => {
      console.log('Manual batch lookup submit:', values)
    },
    []
  )

  const batchLookupDropdownOptions = async (input: string): Promise<DropDownItem[]> => {
    const filtered = allBatches.filter((batch) => {
      const name = batch.batchName?.toLowerCase() || ''
      const id = String(batch.batchId ?? '')
      return (
        name.includes(input.toLowerCase()) || id.includes(input)
      )
    })

    return filtered.map((batch) => ({
      label: `${batch.batchId} - ${batch.batchName}`,
      value: batch.batchId?.toString() ?? '',
    }))
  }



  return {
    allBatches,
    initialValues,
    handleSubmitBatchLookupTx,
    batchLookupDropdownOptions,
  }
}
